export default __webpack_public_path__ + "static/media/chain-10.f5d4a323.png";